import type React from "react";
import gifs from "../../assets/icons/gifs.json";
import { ButtonFluxi } from "../common/Buttons/ButtonFluxi/ButtonFluxi";
import Loader from "../common/Loader";

interface ConfirmationDialogProps {
  title: string;
  description: string;
  imageSrc?: string;
  imageAlt?: string;
  titleColor?: string;
  descriptionColor?: string;
  handleAction?: () => void;
  actionText?: string;
  handleCancel?: () => void;
  cancelText?: string;
  loading?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  title,
  description,
  imageSrc = gifs.error,
  imageAlt = "confirmation-icon",
  titleColor = "text-blue-700",
  descriptionColor = "text-gray-500",
  handleAction,
  actionText = "Confirm",
  handleCancel,
  cancelText = "Cancel",
  loading = false,
}) => {
  return (
    <div className="flex flex-col items-center gap-2">
      {imageSrc && (
        <div className="w-32 h-32 flex justify-center items-center">
          <img
            src={imageSrc}
            alt={imageAlt}
            width={124}
            height={124}
            className="object-contain"
          />
        </div>
      )}

      <div className="flex flex-col items-center gap-1 max-w-xs">
        <h2 className={`text-center text-xl font-bold ${titleColor}`}>
          {title}
        </h2>
        <p className={`text-center text-sm ${descriptionColor}`}>
          {description}
        </p>
        {handleAction && (
          <div className="mt-4 flex justify-center items-center gap-2">
            {loading ? (
              <ButtonFluxi onClick={handleAction} text={actionText} isEffect={false} />
            ) : (
              <Loader />
            )}
            {handleCancel && (
              <ButtonFluxi onClick={handleCancel} text={cancelText} isEffect={false} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfirmationDialog;
